import img5 from "../../assets/images/Screenshot 2022-10-06 at 1.36.35 AM.png";
import img3 from "../../assets/images/bCKGROUND.png";
import img1 from "../../assets/images/Bigbee logo final 2 (1).png";
import img4 from "../../assets/images/Bigbee logo final 2.png";
import { Fade, Flip, Slide } from "react-awesome-reveal";
import React, { useEffect, useRef, useState } from "react";

import img41 from "../../assets/images/output-onlinepngtools.png";
import img11 from "../../assets/images/img1.jpg";
import img22 from "../../assets/images/img2.jpg";
import img33 from "../../assets/images/img3.jpg";
import img44 from "../../assets/images/Blowing rocket 3d cartoon style icon.png";
import img45 from "../../assets/images/top-view-manager-woman-analyzing-financial-paperwork-strategy-typing-expertise-laptop.jpg";
import img46 from "../../assets/images/300239689_771339610773147_6261013368405779958_n.jpg";
import img47 from "../../assets/images/busy-business-people-walking.jpg";
import img48 from "../../assets/images/wad3mostkr.jpeg";
import img49 from "../../assets/images/krisp.jpg";
import img50 from "../../assets/images/dinafarm.jpg";
import img51 from "../../assets/images/ethad.jpeg";

import "animate.css/animate.min.css";
import MyComponent from "./countup";
import "./index.scss";
import "animate.css";
import { Link, NavLink } from "react-router-dom";
import { BrowserView, isMobile, MobileView } from "react-device-detect";
import Loader from "react-loaders";
import ArrowAnimation from "./arrow";
import StarBackground from "./stars";
function Home() {
  const [isAnimated, setIsAnimated] = useState(false);
  const [isAnimated1, setIsAnimated1] = useState(false);
  const elementRef = useRef(null);
  const elementRef1 = useRef(null);
  const [widthBorder3, setBorder3] = useState(20);
  const [visibleDiv, setVisibleDiv] = useState(1);

  const nextDiv = () => {
    const maxDivs = 5;
    if (visibleDiv < maxDivs) {
      incBorder();
      setVisibleDiv(visibleDiv + 1);
    }
  };
  function incBorder() {
    setBorder3(widthBorder3 + 20);
  }
  const handleOnClick = () => {
    nextDiv();
  };
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsAnimated(true);
          }
        });
      },
      { threshold: 1.0 }
    );
    const observer1 = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsAnimated1(true);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }
    if (elementRef1.current) {
      observer1.observe(elementRef1.current);
    }

    // Cleanup observer on component unmount
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <main>
      <div className="carousel-inner">
        <div className="item active">
          <img className="home-background" src={img45} />
          <div className="page-open">
            <div id="pageopenleft">
              <img className="title" src={img41} />
              <h1 className="title ">
                A Full Integrated Marketing Services Agency 360°{" "}
              </h1>
              <p id="about-p">
                Building a cherished brand isn’t just about the item or
                administration a business moves, however the associations it
                makes with the general population who love and trust it.
              </p>
              <i class="fa-solid fa-chart-simple fa-5x "></i>
              <i class="fa-solid fa-lightbulb fa-5x "></i>
              <i class="fa-solid fa-wand-magic-sparkles fa-5x bounce"></i>
              <div className="buttons">
                <a
                  className="btn  btn-outline btn-warning call"
                  href="tel:01553689004"
                >
                  Call Us
                </a>
                <NavLink
                  className="btn  btn-outline btn-warning call2"
                  to="/contact"
                >
                  Call Us
                </NavLink>
                <a
                  className="btn  btn-outline btn-warning"
                  href="mailto:info@bigbee-eg.com"
                >
                  Email Us
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="item">
          <img src={img3} />
        </div>
        <div className="item">
          <img src={img3} />
        </div>
      </div>

      <div>
        <div className="open-border"></div>

        <div className="open" ref={elementRef1}>
          {/* <div
            id="arr"
            style={{
              borderRadius: "2px",
              color: "#efc52b",
              paddingTop: "200px",
              position: "absolute",
            }}
          >
            {isAnimated1 && <ArrowAnimation />}
          </div> */}
          <div className="carousel-inner">
            <div className="bee-img">
              <img className="fade2" src={img4} />
              <img src={img1} className="fade1" />
            </div>

            {/* <NavLink className={"checkout"} to="clients">
              <h1 id="checkOur" className={` ${isAnimated1 ? "animate1" : ""}`}>
                Check out our clients
              </h1>
            </NavLink> */}
          </div>
          <div
            style={{
              position: "absolute",
              width: "100vw",
              height: "70vh",
              zIndex: 0,
            }}
          >
            <StarBackground />
          </div>

          <div className="left-div">
            <div id="counterup">
              <div
                id="startClients"
                style={{ display: "flex", paddingLeft: "px" }}
              >
                <MyComponent data={{ num: 30, name: "CLIENTS" }} />
                <i
                  class="fa-solid fa-bell-concierge"
                  style={{ paddingTop: "25px", paddingLeft: "10px" }}
                ></i>
              </div>
              <br></br>
              <br></br>
              <div style={{ display: "flex" }}>
                <MyComponent data={{ num: 15, name: "COMPLETED PROJECTS" }} />
                <i
                  class="fa-solid fa-circle-check"
                  style={{ paddingTop: "25px", paddingLeft: "10px" }}
                ></i>
              </div>
              <br></br>
              <br></br>
              <div style={{ display: "flex" }}>
                <MyComponent data={{ num: 10, name: "RUNNING PROJECTS" }} />
                <i
                  class="fa-solid fa-compass-drafting"
                  style={{ paddingTop: "25px", paddingLeft: "10px" }}
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="fixed-bg">
        <div className="open-border"></div>
        <NavLink to={"/contact"}>
          <Slide
            direction="up"
            duration={2000}
            triggerOnce={true}
            damping={true}
          >
            {/* <img className="rocket-img" src={img44}></img> */}
          </Slide>
        </NavLink>
        <div className="stacked-divs">
          <h1 className={`ani ${isAnimated ? "animate" : "animateF"}`}>
            LET'S TAKE YOU ON
          </h1>
          <h1
            ref={elementRef}
            className={`ani ${isAnimated ? "animate2" : "animate2F"}`}
          >
            A TOUR OF OUR WORK
          </h1>

          <div
            className={`branding1 ${isAnimated ? "branding" : ""}`}
            style={{
              color: "#efc52b",
              width: "100vw",
              height: "100vh", // Full screen height
              position: "relative", // Allows positioning of button
              textAlign: "center", // Centers title and div content
              display: "flex",
              flexDirection: "column",
              justifyContent: "center", // Centers everything
              alignItems: "center",
              gap: "10px", // Reduces space between elements
            }}
          >
            {/* Div 1 - Image */}
            {visibleDiv === 1 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                {/* Title */}
                <h1
                  className="title"
                  style={{ fontSize: "2rem", margin: "10px 0" }}
                >
                  " A sneak peek from our event "the premiere of الوضع مستقر" "
                </h1>

                <a href="https://www.instagram.com/p/Ck5VGgKI6-A/?igsh=bWNteDU5eTNuaHlr">
                  <img
                    style={{
                      maxWidth: "95%", // Responsive image
                      height: "auto",
                      maxHeight: "500px", // Adjusted max height for less space
                      margin: "5px 0", // Reduces space around image
                      borderRadius: "20px", // Rounded corners
                    }}
                    src={img48}
                    alt="OSN"
                  />
                </a>
              </div>
            )}

            {/* Div 2 - Image */}
            {visibleDiv === 2 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                {/* Title */}
                <h1
                  className="title"
                  style={{ fontSize: "2rem", margin: "10px 0" }}
                >
                  " A Sneak peak from our event for Hardees Egypt™ "
                </h1>

                <a href="https://www.instagram.com/p/Che9LInKd_v/?igsh=MWhqczYyN2dqanZqaw==">
                  <img
                    style={{
                      maxWidth: "100%", // Responsive image
                      height: "auto",
                      maxHeight: "500px", // Adjusted max height for less space
                      margin: "5px 0", // Reduces space around image
                      borderRadius: "20px", // Rounded corners
                    }}
                    src={img46}
                    alt="Hardees"
                  />
                </a>
              </div>
            )}

            {/* Div 3 - Image */}
            {visibleDiv === 3 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                {/* Title */}
                <h1
                  className="title"
                  style={{ fontSize: "2rem", margin: "10px 0" }}
                >
                  " We'are pleased to be a part of krispy kreme first
                  anniversary in Egypt! "
                </h1>

                <a href="https://www.instagram.com/p/Che9LInKd_v/?igsh=MWhqczYyN2dqanZqaw==">
                  <img
                    style={{
                      maxWidth: "100%", // Responsive image
                      height: "auto",
                      maxHeight: "500px", // Adjusted max height for less space
                      margin: "5px 0", // Reduces space around image
                      borderRadius: "20px", // Rounded corners
                    }}
                    src={img49}
                    alt="kirspykreme"
                  />
                </a>
              </div>
            )}

            {/* Div 4 - Image */}
            {visibleDiv === 4 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                {/* Title */}
                <h1
                  className="title"
                  style={{ fontSize: "2rem", margin: "10px 0" }}
                >
                  " It's been an incredible journey working on this grand
                  opening for Dina Farms! "
                </h1>

                <a href="https://www.instagram.com/p/CxVn0UUIJlc/?igsh=Mnl2azkxOW1tam9w">
                  <img
                    style={{
                      maxWidth: "100%", // Responsive image
                      height: "auto",
                      maxHeight: "500px", // Adjusted max height for less space
                      margin: "5px 0", // Reduces space around image
                      borderRadius: "20px", // Rounded corners
                    }}
                    src={img50}
                    alt="Dina farms"
                  />
                </a>
              </div>
            )}

            {/* Div 5 - Image */}
            {visibleDiv === 5 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                {/* Title */}
                <h1
                  className="title"
                  style={{ fontSize: "2rem", margin: "10px 0" }}
                >
                  " We'are pleased to be a part of event "يوم التأسيس" of Etihad
                  club. "
                </h1>

                <a href="https://www.instagram.com/p/C6tnFLForWP/?img_index=2&igsh=Zmw3NzlvbThrbXMz">
                  <img
                    style={{
                      maxWidth: "100%", // Responsive image
                      height: "auto",
                      maxHeight: "500px", // Adjusted max height for less space
                      margin: "5px 0", // Reduces space around image
                      borderRadius: "20px", // Rounded corners
                    }}
                    src={img51}
                    alt="Ethad"
                  />
                </a>
              </div>
            )}

            {/* NEXT Button */}
            <button
              style={{
                marginTop: "10px", // Reduces space above button
              }}
              className="btn btn-outline btn-warning"
              onClick={handleOnClick}
            >
              NEXT
            </button>
          </div>
        </div>
      </div>
      <div
        className="borderBottom3"
        style={{ marginBottom: "10px", width: `${widthBorder3}%` }}
      ></div>
      {/* <div className="news-events"> 
        <h1 className="opening">OUR LASTEST EVENTS </h1>
        <div className="news-border"></div>

        <div className="carousel2">
          <div id="myCarousel2" className="carousel slide" data-ride="carousel">
            <ol className="carousel-indicators">
              <li
                data-target="#myCarousel2"
                data-slide-to="0"
                className="active"
              ></li>
              <li data-target="#myCarousel2" data-slide-to="1"></li>
              <li data-target="#myCarousel2" data-slide-to="2"></li>
            </ol>

            <div className="carousel-inner">
              <div className="item active">
                <a href="#">
                  <img id="item-active" src={img22} alt="Los Angeles" />
                </a>
                <div className="carousel-caption">
                  <h3>Hardee's</h3>
                </div>
              </div>

              <div className="item">
                <a href="#">
                  <img id="item-active" src={img11} alt="Los Angeles" />
                </a>
                <div className="carousel-caption">
                  <h3>Hardee's</h3>
                  <p></p>
                </div>
              </div>
              <div className="item">
                <a href="#">
                  <img id="item-active" src={img33} alt="Los Angeles" />
                </a>
                <div className="carousel-caption">
                  <h3>Hardee's</h3>
                  <p></p>
                </div>
              </div>
            </div>

            <a
              className="left carousel-control"
              href="#myCarousel2"
              data-slide="prev"
            >
              <span className="glyphicon glyphicon-chevron-left"></span>
              <span className="sr-only">Previous</span>
            </a>
            <a
              className="right carousel-control"
              href="#myCarousel2"
              data-slide="next"
            >
              <span className="glyphicon glyphicon-chevron-right"></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>
      */}
    </main>
  );
}
export default Home;
